import { assetLoader, audioPlayer } from "../PhaserExtension";
import * as GameModel from "../models/GameModel";
import * as States from "./States";
import { flump } from "../PhaserExtension";
import FlumpObject from "../general/objects/FlumpObject";

export default class SharedLoadState extends Phaser.State {
    preload() {
        // Preload any assets to be shared throughout the app.
        assetLoader.preloadAssetPacks(this.game, ["main"]);
        this.game.load.onFileComplete.add(this.onFileComplete, this);
    }

    onFileComplete(progress, cacheKey, success, totalLoaded, totalFiles)
    {
        if(cacheKey == "mainConfig")
        {
            this.mainConfig = this.game.cache.getJSON("mainConfig");
            var platform = this.game.device.desktop ? "desktop" : "mobile";
            var language = GameModel.data.english ? "en" : "es";
            this.game.load.audio("prompt", this.mainConfig.variables.promptPath[platform][language]);
            this.game.load.audio("promptHere", this.mainConfig.variables.promptHerePath[platform][language]);
            audioPlayer.setupChannels(this.mainConfig.sounds.channels);
            this.game.load.onFileComplete.remove(this.onFileComplete, this);
        }
    }

    create() {
        // Added any shared assets like Flump libraries or sound channels.
        flump.addLibrary(this.game, "mainFlump", "assets/main/flump/");
        flump.addLibrary(this.game, "groverFlump", "assets/storyCircle/groverFlump/");

        GameModel.data.transition = new FlumpObject(this.game, this.mainConfig.assets.transition, "mainFlump");
        GameModel.data.loadBar = new Phaser.Sprite(this.game, this.game.width / 2, this.game.height / 2 + 222, "loadBar");
        GameModel.data.loadBar.x -= GameModel.data.loadBar.width / 2;
        GameModel.data.loadBar.name = "Load Bar";

        this.game.state.start(States.TITLE);
    }
}
